import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import doctor_sample from '../assets/doctor_sample.jpg';
import { RxHeart, RxHeartFilled } from "react-icons/rx";
import { callApi, CDN_URL, formatDate, formatMoneyShorten } from "../Helpers";
import { FaRegCommentDots } from "react-icons/fa";
import { MdPerson } from "react-icons/md";

export default function View({ data }) {
	const appContext = useContext(AppContext);


	useEffect(() => {
		if(data) {
			
		}
	}, [data])

	return (
		<div
			style={{
				width: "100%",
				padding: "10px",
				borderRadius: "10px",
				marginTop: "5px",
				marginBottom: "5px",
			}}
			className="bg-surface"
		>
			<div
				style={{
					fontSize: "10px"
				}}
				className="d-flex text-muted font-bold"
			>
				<MdPerson className="mNoMargin align-self-center" size={16}/>
				<span className="mNoMargin align-self-center" style={{ paddingLeft: "4px" }}>{data.username || "AfyaMingle User"}</span>
			</div>

			<h6
				style={{
					fontSize: "14px"
				}}
				className="mt-2 mb-2"
			>
				{data.body}
			</h6>

			<h6
				style={{
					fontSize: "10px"
				}}
				className="text-end font-bold text-muted"
			>
				{formatDate(data.dateCreated)}
			</h6>
		</div>
	);
}
